import { PageHero } from "@/components/sections/PageHero";
import { COMPANY, IMAGES } from "@/lib/site";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <PageHero eyebrow="Legal" title="Terms of Service" image={IMAGES.steelTexture} />
      <section className="section px-6 lg:px-10 max-w-4xl space-y-6 text-zinc-300 leading-relaxed">
        <p><strong className="text-white">Effective Date:</strong> {new Date().toLocaleDateString()}</p>
        <p>Use of this website is subject to the following terms. By accessing this site you agree to be bound by them.</p>

        <h2 className="font-display text-3xl text-white tracking-tight pt-6">Website Content</h2>
        <p>Site content is provided for informational purposes. Quotes, lead times, and specifications provided online are indicative and confirmed in writing before work commences.</p>

        <h2 className="font-display text-3xl text-white tracking-tight pt-6">Intellectual Property</h2>
        <p>All content, marks, and materials on this site are the property of {COMPANY.name} unless otherwise noted, and may not be reproduced without written permission.</p>

        <h2 className="font-display text-3xl text-white tracking-tight pt-6">Warranty & Liability</h2>
        <p>Coating warranties and service terms are governed by individual customer purchase agreements and are not created by this website.</p>

        <h2 className="font-display text-3xl text-white tracking-tight pt-6">Contact</h2>
        <p>{COMPANY.email} · {COMPANY.phone}</p>
      </section>
    </div>
  );
}
